// import React, { useState, useEffect } from "react";
// import { auth, provider, signInWithPopup } from "../../FirebaseConfig";
// import { useLocation, useNavigate } from "react-router-dom";
// import LoginImage from "../assets/Login.png";

// function LoginSpace() {
//   const [isChecked, setIsChecked] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const navigate = useNavigate();

//   const location = useLocation();
//   // Handle Google Sign-In
//   const handleGoogleSignIn = async (e) => {
//     e.preventDefault();
//     if (!isChecked) {
//       setShowPopup(true);
//       return;
//     }

//     try {
//       const result = await signInWithPopup(auth, provider);
//       console.log("User Signed In:", result.user);
//       const queryParams = new URLSearchParams(location.search);
//     const redirectPath = queryParams.get("redirect") || "/";
//     const productId = queryParams.get("productId");
//     const quantity = queryParams.get("quantity");

//     // Append productId and quantity if present
//     const finalRedirect = productId && quantity
//       ? `${redirectPath}?productId=${productId}&quantity=${quantity}`
//       : redirectPath;

//     navigate(finalRedirect);
    
//       // navigate("/dashboard"); // Redirect after successful login
//     } catch (error) {
//       console.error("Sign-in error:", error);
//     }
//   };

//   return (
//     <div
//       className="h-screen flex items-center justify-center bg-cover bg-center"
//       style={{ backgroundImage: `url(${LoginImage})` }}
//     >
//       <div className="bg-white/80 backdrop-blur-md p-8 rounded-xl shadow-lg w-full max-w-md text-center">
//         <h2 className="text-2xl font-semibold text-gray-800">Welcome Back</h2>
//         <p className="text-gray-600 mt-2">Sign in to continue</p>

//         {/* Checkbox for Terms & Conditions */}
//         <div className="mt-6 flex items-center space-x-2">
//           <input
//             type="checkbox"
//             checked={isChecked}
//             onChange={() => setIsChecked(!isChecked)}
//             className="h-4 w-4 text-orange-500 border-gray-300 rounded"
//           />
//           <label className="text-sm text-gray-600">
//             By logging in, I agree to 
//             <a href="/privacy-policy" target="_blank" className="text-orange-500 font-semibold ml-1 hover:underline">
//               Terms & Conditions
//             </a>
//           </label>
//         </div>

//         {/* Google Sign-In Button */}
//         <button
//           onClick={handleGoogleSignIn}
//           className="mt-6 flex items-center justify-center bg-white text-gray-700 border border-gray-300 px-6 py-2 rounded-lg shadow hover:shadow-md hover:bg-gray-100 transition w-full"
//         >
//           <img
//             src="https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-suite-everything-you-need-know-about-google-newest-0.png"
//             alt="Google Sign In"
//             className="h-6 w-6 mr-2"
//           />
//           Sign in with Google
//         </button>

//         {/* Popup for Terms & Conditions */}
//         {showPopup && (
//           <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//             <div className="bg-white p-6 rounded-lg shadow-lg text-center">
//               <h3 className="text-lg font-semibold">Please Agree to Terms & Conditions</h3>
//               <p className="text-gray-600 mt-2">You must accept the terms before signing in.</p>
//               <button
//                 onClick={() => setShowPopup(false)}
//                 className="mt-4 bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition"
//               >
//                 OK
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default LoginSpace;

import React, { useState } from "react";
import { auth, provider, signInWithPopup } from "../../FirebaseConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { AlertCircle, ArrowRight } from "lucide-react";
import LoginImage from "../assets/Login.png"; // Ensure this path is correct

function LoginSpace() {
  const [isChecked, setIsChecked] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Handle Google Sign-In
  const handleGoogleSignIn = async (e) => {
    e.preventDefault();
    if (!isChecked) {
      setShowPopup(true);
      return;
    }

    try {
      setIsLoading(true);
      const result = await signInWithPopup(auth, provider);
      console.log("User Signed In:", result.user);
      
      // const queryParams = new URLSearchParams(location.search);
      // const redirectPath = queryParams.get("redirect") || "/";
      // const productId = queryParams.get("productId");
      // const quantity = queryParams.get("quantity");

      // // Append productId and quantity if present
      // const finalRedirect = productId && quantity
      //   ? `${redirectPath}?productId=${productId}&quantity=${quantity}`
      //   : redirectPath;

      // navigate(finalRedirect);
      const queryParams = new URLSearchParams(location.search);
    let redirectPath = queryParams.get("redirect") || "/";
    let productId = queryParams.get("productId");
    let quantity = queryParams.get("quantity");

    // If redirect contains nested query strings (e.g. /checkout?productId=...&quantity=...)
    if (redirectPath.includes("?")) {
      const [path, nestedQuery] = redirectPath.split("?");
      const nestedParams = new URLSearchParams(nestedQuery);
      
      redirectPath = path;
      if (!productId) productId = nestedParams.get("productId");
      if (!quantity) quantity = nestedParams.get("quantity");
    }

    // Build final redirect URL safely
    const finalParams = new URLSearchParams();
    if (productId) finalParams.set("productId", productId);
    if (quantity) finalParams.set("quantity", quantity);

    const queryString = finalParams.toString();
    const finalRedirect = queryString ? `${redirectPath}?${queryString}` : redirectPath;

    navigate(finalRedirect);
    
    } catch (error) {
      console.error("Sign-in error:", error);
      setIsLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden selection:bg-orange-200">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${LoginImage})` }}
      />
      <div className="absolute inset-0 z-10 bg-black/40 backdrop-blur-[2px]" />

      {/* Main Login Card */}
      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="relative z-20 w-full max-w-md mx-4 bg-white/90 backdrop-blur-xl p-8 sm:p-10 rounded-[2rem] shadow-2xl border border-white/50"
      >
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-orange-100 mb-4 shadow-inner">
            <span className="text-3xl">🍯</span>
          </div>
          <h2 className="text-3xl font-black text-gray-900 tracking-tight">Welcome Back</h2>
          <p className="text-gray-500 mt-2 font-medium">Sign in to continue your journey</p>
        </div>

        <div className="space-y-6">
          {/* Terms & Conditions Checkbox */}
          <label className="flex items-start gap-3 p-4 rounded-2xl bg-gray-50/50 border border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors group">
            <div className="relative flex items-center mt-0.5">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
                className="peer h-5 w-5 cursor-pointer appearance-none rounded-md border-2 border-gray-300 checked:border-orange-500 checked:bg-orange-500 transition-all"
              />
              <svg
                className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-3.5 w-3.5 text-white opacity-0 peer-checked:opacity-100 pointer-events-none transition-opacity"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="3"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span className="text-sm text-gray-600 leading-relaxed select-none">
              By logging in, I agree to the{" "}
              <a 
                href="/privacy-policy" 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()} // Prevents checkbox toggle when clicking link
                className="text-orange-600 font-bold hover:text-orange-700 hover:underline decoration-2 underline-offset-2 transition-colors"
              >
                Terms & Conditions
              </a>
            </span>
          </label>

          {/* Google Sign-In Button */}
          <button
            onClick={handleGoogleSignIn}
            disabled={isLoading}
            className="w-full flex items-center justify-center gap-3 bg-white text-gray-700 border border-gray-200 px-6 py-4 rounded-2xl font-bold text-lg shadow-sm hover:shadow-md hover:border-gray-300 hover:bg-gray-50 transition-all active:scale-[0.98] disabled:opacity-70 disabled:cursor-not-allowed group"
          >
            {isLoading ? (
              <div className="w-6 h-6 border-2 border-gray-300 border-t-orange-500 rounded-full animate-spin" />
            ) : (
              <>
                <img
                  src="https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-suite-everything-you-need-know-about-google-newest-0.png"
                  alt="Google"
                  className="h-6 w-6 object-contain group-hover:scale-110 transition-transform"
                />
                <span>Sign in with Google</span>
                <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-gray-800 transition-colors ml-auto group-hover:translate-x-1" />
              </>
            )}
          </button>
        </div>
      </motion.div>

      {/* Modern Popup for Terms & Conditions */}
      <AnimatePresence>
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="absolute inset-0 bg-black/60 backdrop-blur-sm"
              onClick={() => setShowPopup(false)}
            />
            <motion.div 
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="relative z-50 bg-white p-6 sm:p-8 rounded-3xl shadow-2xl w-full max-w-sm text-center"
            >
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <AlertCircle className="w-8 h-8 text-orange-600" />
              </div>
              <h3 className="text-2xl font-black text-gray-900 mb-2">Action Required</h3>
              <p className="text-gray-500 font-medium mb-8">
                Please accept the Terms & Conditions before signing in.
              </p>
              <button
                onClick={() => {
                  setShowPopup(false);
                  setIsChecked(true); // Optionally auto-check it for them to save a click
                }}
                className="w-full bg-orange-500 text-white px-6 py-4 rounded-xl font-bold text-lg hover:bg-orange-600 shadow-lg shadow-orange-500/30 transition-all active:scale-[0.98]"
              >
                Accept & Continue
              </button>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default LoginSpace;
